import { createSlice } from '@reduxjs/toolkit';
import { ICaseBrowsingHistoryDetails } from 'src/components/CaseHistory/interfaces';

const initialState = {
  caseBrowsingHistoryDetails: []
} as ICaseBrowsingHistoryDetails;

const caseHistorySlice = createSlice({
  name: 'caseHistorySlice',
  initialState,
  reducers: {
    setCaseBrowsingHistoryDetails(state, action) {
      state.caseBrowsingHistoryDetails = action.payload;
    }
  }
});

export const { setCaseBrowsingHistoryDetails } = caseHistorySlice.actions;

export default caseHistorySlice.reducer;
